import PropTypes from "prop-types";
import React from "react";
import * as Device from "redux-store/devices/selectors";

// TODO(jhohman): refactor this to just take device_id and use
// device-statuses/selectors getStatus().
function DeviceStatusIcon(props) {
  const { device, deviceStatusOnline } = props;

  const deviceStatus = Device.getStatus(device);
  const { iconClass, textClass } = deviceStatus;
  const classes = `fa fa-2x ${iconClass} ${textClass}`;

  const offlineClass = deviceStatusOnline === false ? "offline" : "";

  return (
    <span className={`device-status online-component ${offlineClass}`}>
      <i className={classes} title={deviceStatus.label} />
    </span>
  );
}

DeviceStatusIcon.propTypes = {
  device: PropTypes.object.isRequired,
  deviceStatusOnline: PropTypes.bool,
};

export { DeviceStatusIcon };
